module.exports = __webpack_public_path__ + "static/portfolio-7-cbf179f5f382ef4552da211e0f2f6ee0.jpg";